export default __webpack_public_path__ + "static/media/Pipe_duotone_line.3074de1d.svg";